import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4" role="alert">
          <div className="max-w-md w-full p-6 bg-white border border-red-200 rounded-xl shadow-lg text-center">
            <h1 className="text-xl font-bold text-red-600 mb-2">Something went wrong.</h1>
            <p className="text-gray-600 text-sm mb-4">
              The application hit an unexpected error. Reloading the page usually fixes it.
            </p>
            <details className="text-left">
              <summary className="cursor-pointer text-sm text-gray-500">Error details</summary>
              <pre className="mt-2 p-3 bg-gray-100 rounded-lg text-xs overflow-auto text-left">
                {this.state.error?.toString()}
              </pre>
            </details>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-4 px-4 py-2 bg-primary text-secondary rounded-lg font-medium hover:bg-primary-light transition-colors"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 